import { createContext } from 'react';

export type BillingHeaderContextType = {
  billingHeader: BillingHeaderContextTo | undefined;
  modifyBillingHeader: (address: BillingHeaderContextTo) => void;
};

export const billingHeaderContext = createContext<
  BillingHeaderContextType | undefined
>(undefined);

export type BillingHeaderContextTo = {
  billingAddress?: any[];
  cnpjNumber?: string;
  hasIE?: boolean;
  resellerType?: string;
  shipToProvince?: string;
  shipToUF?: string;
  shipingAddress?: any[];
};
